import React from 'react';
import PropTypes from 'prop-types';

import { getHelpCardTitle } from 'common/helpCardHelpers';

import SrBox from 'client/components/SrBox';
import SrPartnerOverviewPageHeader from 'client/components/SrPartnerOverviewPageHeader';
import SrFlex from 'client/components/SrFlex';
import SrPartnerContactAccountManager from 'client/components/SrPartnerContactAccountManager';
import SrDataTableSetupInProgressPartnerListings from 'client/components/SrDataTableSetupInProgressPartnerListings';
import SrDataTableSetupCompletedPartnerListings from 'client/components/SrDataTableSetupCompletedPartnerListings';
import SrHelpCardSection from 'client/components/SrHelpCardSection/SrHelpCardSection';
import SrDataTableUninstallsPartnerListings from 'client/components/SrDataTableUninstallsPartnerListings';

const PartnerOverviewPageSunRise = ({
  partner,
  dispatch,
  currentUser,
  helpCards,
  marketingPartnerListing,
  onReloadDataTableMarketingPartnerListing,
}) => {
  return (
    <>
      <SrPartnerOverviewPageHeader partner={partner} currentUser={currentUser} />
      <SrBox margin="0 16px">
        <div
          className="GoingToMarketSection"
          style={{
            scrollMargin: '50px',
          }}
        >
          <SrDataTableSetupInProgressPartnerListings
            partner={partner}
            dispatch={dispatch}
            reloadDataTableMarketingPartnerListing={onReloadDataTableMarketingPartnerListing}
          />
        </div>
        <SrDataTableSetupCompletedPartnerListings
          partner={partner}
          dispatch={dispatch}
          currentUser={currentUser}
        />
        <SrDataTableUninstallsPartnerListings partner={partner} />
        <SrFlex width="100%" justify="center" marginTop="120px">
          <SrPartnerContactAccountManager marketingPartnerListing={marketingPartnerListing} />
        </SrFlex>
        {helpCards && helpCards.length > 0 && (
          <SrBox marginTop="120px">
            <SrHelpCardSection helpCards={helpCards} title={getHelpCardTitle({ partner })} />
          </SrBox>
        )}
      </SrBox>
    </>
  );
};

PartnerOverviewPageSunRise.propTypes = {
  dispatch: PropTypes.func,
  partner: PropTypes.object,
  currentUser: PropTypes.object,
  marketingPartnerListing: PropTypes.object,
  onReloadDataTableMarketingPartnerListing: PropTypes.func,
};

PartnerOverviewPageSunRise.displayName = 'PartnerOverviewPageSunRise';

export default PartnerOverviewPageSunRise;
